// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as React from "react";
import * as Future from "rescript-future/src/Future.res.js";
import * as Scalar from "../../core/Scalar.res.js";
import * as ApolloHelpers from "../../helpers/ApolloHelpers.res.js";
import * as Client from "@apollo/client";
import * as ApolloClient__React_Hooks_UseMutation from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseMutation.res.js";

let Raw = {};

let query = Client.gql(["mutation updateProduct_internalNote($id: ID!, $input: InputUpdateProduct!)  {\nupdateProduct(id: $id, input: $input)  {\n__typename  \nid  \ninternalNote  \n}\n\n}\n"]);

function parse(value) {
  let value$1 = value.updateProduct;
  let value$2 = value$1.internalNote;
  return {
    updateProduct: {
      __typename: value$1.__typename,
      id: value$1.id,
      internalNote: !(value$2 == null) ? Scalar.Text.parse(value$2) : undefined
    }
  };
}

function serialize(value) {
  let value$1 = value.updateProduct;
  let value$2 = value$1.internalNote;
  let internalNote = value$2 !== undefined ? Scalar.Text.serialize(value$2) : null;
  let value$3 = value$1.id;
  let value$4 = value$1.__typename;
  let updateProduct = {
    __typename: value$4,
    id: value$3,
    internalNote: internalNote
  };
  return {
    updateProduct: updateProduct
  };
}

function serializeInputObjectInputUpdateProductMetaData(inp) {
  let a = inp.shopifyProductId;
  return {
    shopifyProductId: a !== undefined ? a : undefined
  };
}

function serializeInputObjectInputUpdateProduct(inp) {
  let a = inp.name;
  let a$1 = inp.designation;
  let a$2 = inp.color;
  let a$3 = inp.kind;
  let a$4 = inp.family;
  let a$5 = inp.producer;
  let a$6 = inp.country;
  let a$7 = inp.region;
  let a$8 = inp.beerType;
  let a$9 = inp.wineType;
  let a$10 = inp.whiteWineType;
  let a$11 = inp.internalNote;
  let a$12 = inp.taxId;
  let a$13 = inp.categoryId;
  let a$14 = inp.metadata;
  return {
    name: a !== undefined ? a : undefined,
    designation: a$1 !== undefined ? a$1 : undefined,
    color: a$2 !== undefined ? (
        a$2 === "ORANGE" ? "ORANGE" : (
            a$2 === "RED" ? "RED" : (
                a$2 === "AMBER" ? "AMBER" : (
                    a$2 === "DARK" ? "DARK" : (
                        a$2 === "BLACK" ? "BLACK" : (
                            a$2 === "BLOND" ? "BLOND" : (
                                a$2 === "ROSE" ? "ROSE" : "WHITE"
                              )
                          )
                      )
                  )
              )
          )
      ) : undefined,
    kind: a$3 !== undefined ? (
        a$3 === "SPIRITUOUS" ? "SPIRITUOUS" : (
            a$3 === "BEER" ? "BEER" : (
                a$3 === "WINE" ? "WINE" : "SIMPLE"
              )
          )
      ) : undefined,
    family: a$4 !== undefined ? a$4 : undefined,
    producer: a$5 !== undefined ? a$5 : undefined,
    country: a$6 !== undefined ? a$6 : undefined,
    region: a$7 !== undefined ? a$7 : undefined,
    beerType: a$8 !== undefined ? a$8 : undefined,
    wineType: a$9 !== undefined ? (
        a$9 === "EFFERVESCENT" ? "EFFERVESCENT" : "STILL"
      ) : undefined,
    whiteWineType: a$10 !== undefined ? (
        a$10 === "SWEET" ? "SWEET" : (
            a$10 === "SEMIDRY" ? "SEMIDRY" : (
                a$10 === "SOFT" ? "SOFT" : "DRY"
              )
          )
      ) : undefined,
    internalNote: a$11 !== undefined ? a$11 : undefined,
    taxId: a$12 !== undefined ? a$12 : undefined,
    categoryId: a$13 !== undefined ? a$13 : undefined,
    metadata: a$14 !== undefined ? serializeInputObjectInputUpdateProductMetaData(a$14) : undefined
  };
}

function serializeVariables(inp) {
  return {
    id: inp.id,
    input: serializeInputObjectInputUpdateProduct(inp.input)
  };
}

function makeVariables(id, input, param) {
  return {
    id: id,
    input: input
  };
}

function makeInputObjectInputUpdateProduct(name, designation, color, kind, family, producer, country, region, beerType, wineType, whiteWineType, internalNote, taxId, categoryId, metadata, param) {
  return {
    name: name,
    designation: designation,
    color: color,
    kind: kind,
    family: family,
    producer: producer,
    country: country,
    region: region,
    beerType: beerType,
    wineType: wineType,
    whiteWineType: whiteWineType,
    internalNote: internalNote,
    taxId: taxId,
    categoryId: categoryId,
    metadata: metadata
  };
}

function makeInputObjectInputUpdateProductMetaData(shopifyProductId, param) {
  return {
    shopifyProductId: shopifyProductId
  };
}

let UpdateProductMutation_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputUpdateProduct: serializeInputObjectInputUpdateProduct,
  serializeInputObjectInputUpdateProductMetaData: serializeInputObjectInputUpdateProductMetaData,
  makeVariables: makeVariables,
  makeInputObjectInputUpdateProduct: makeInputObjectInputUpdateProduct,
  makeInputObjectInputUpdateProductMetaData: makeInputObjectInputUpdateProductMetaData
};

let include = ApolloClient__React_Hooks_UseMutation.Extend({
  query: query,
  Raw: Raw,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables
});

let use = include.use;

let UpdateProductMutation_useWithVariables = include.useWithVariables;

let UpdateProductMutation = {
  UpdateProductMutation_inner: UpdateProductMutation_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputUpdateProduct: serializeInputObjectInputUpdateProduct,
  serializeInputObjectInputUpdateProductMetaData: serializeInputObjectInputUpdateProductMetaData,
  makeVariables: makeVariables,
  makeInputObjectInputUpdateProduct: makeInputObjectInputUpdateProduct,
  makeInputObjectInputUpdateProductMetaData: makeInputObjectInputUpdateProductMetaData,
  use: use,
  useWithVariables: UpdateProductMutation_useWithVariables
};

let Raw$1 = {};

let query$1 = Client.gql(["mutation ArchiveProductMutation($id: ID!)  {\narchiveProduct(id: $id)  {\n__typename  \nid  \nformattedStatus  \narchivedAt  \n}\n\n}\n"]);

function parse$1(value) {
  let value$1 = value.archiveProduct;
  let value$2 = value$1.formattedStatus;
  let tmp;
  if (value$2 == null) {
    tmp = undefined;
  } else {
    let tmp$1;
    switch (value$2) {
      case "ACTIVE" :
        tmp$1 = "ACTIVE";
        break;
      case "ARCHIVED" :
        tmp$1 = "ARCHIVED";
        break;
      case "INACTIVE" :
        tmp$1 = "INACTIVE";
        break;
      default:
        tmp$1 = {
          NAME: "FutureAddedValue",
          VAL: value$2
        };
    }
    tmp = tmp$1;
  }
  let value$3 = value$1.archivedAt;
  return {
    archiveProduct: {
      __typename: value$1.__typename,
      id: value$1.id,
      formattedStatus: tmp,
      archivedAt: !(value$3 == null) ? Scalar.Datetime.parse(value$3) : undefined
    }
  };
}

function serialize$1(value) {
  let value$1 = value.archiveProduct;
  let value$2 = value$1.archivedAt;
  let archivedAt = value$2 !== undefined ? Scalar.Datetime.serialize(value$2) : null;
  let value$3 = value$1.formattedStatus;
  let formattedStatus = value$3 !== undefined ? (
      typeof value$3 === "object" ? value$3.VAL : (
          value$3 === "ARCHIVED" ? "ARCHIVED" : (
              value$3 === "ACTIVE" ? "ACTIVE" : "INACTIVE"
            )
        )
    ) : null;
  let value$4 = value$1.id;
  let value$5 = value$1.__typename;
  let archiveProduct = {
    __typename: value$5,
    id: value$4,
    formattedStatus: formattedStatus,
    archivedAt: archivedAt
  };
  return {
    archiveProduct: archiveProduct
  };
}

function serializeVariables$1(inp) {
  return {
    id: inp.id
  };
}

function makeVariables$1(id, param) {
  return {
    id: id
  };
}

let ArchiveProductMutation_inner = {
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  makeVariables: makeVariables$1
};

let include$1 = ApolloClient__React_Hooks_UseMutation.Extend({
  query: query$1,
  Raw: Raw$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1
});

let use$1 = include$1.use;

let ArchiveProductMutation_useWithVariables = include$1.useWithVariables;

let ArchiveProductMutation = {
  ArchiveProductMutation_inner: ArchiveProductMutation_inner,
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  makeVariables: makeVariables$1,
  use: use$1,
  useWithVariables: ArchiveProductMutation_useWithVariables
};

let Raw$2 = {};

let query$2 = Client.gql(["mutation UnarchiveProductMutation($id: ID!)  {\nunarchiveProduct(id: $id)  {\n__typename  \nid  \nformattedStatus  \narchivedAt  \n}\n\n}\n"]);

function parse$2(value) {
  let value$1 = value.unarchiveProduct;
  let value$2 = value$1.formattedStatus;
  let tmp;
  if (value$2 == null) {
    tmp = undefined;
  } else {
    let tmp$1;
    switch (value$2) {
      case "ACTIVE" :
        tmp$1 = "ACTIVE";
        break;
      case "ARCHIVED" :
        tmp$1 = "ARCHIVED";
        break;
      case "INACTIVE" :
        tmp$1 = "INACTIVE";
        break;
      default:
        tmp$1 = {
          NAME: "FutureAddedValue",
          VAL: value$2
        };
    }
    tmp = tmp$1;
  }
  let value$3 = value$1.archivedAt;
  return {
    unarchiveProduct: {
      __typename: value$1.__typename,
      id: value$1.id,
      formattedStatus: tmp,
      archivedAt: !(value$3 == null) ? Scalar.Datetime.parse(value$3) : undefined
    }
  };
}

function serialize$2(value) {
  let value$1 = value.unarchiveProduct;
  let value$2 = value$1.archivedAt;
  let archivedAt = value$2 !== undefined ? Scalar.Datetime.serialize(value$2) : null;
  let value$3 = value$1.formattedStatus;
  let formattedStatus = value$3 !== undefined ? (
      typeof value$3 === "object" ? value$3.VAL : (
          value$3 === "ARCHIVED" ? "ARCHIVED" : (
              value$3 === "ACTIVE" ? "ACTIVE" : "INACTIVE"
            )
        )
    ) : null;
  let value$4 = value$1.id;
  let value$5 = value$1.__typename;
  let unarchiveProduct = {
    __typename: value$5,
    id: value$4,
    formattedStatus: formattedStatus,
    archivedAt: archivedAt
  };
  return {
    unarchiveProduct: unarchiveProduct
  };
}

function serializeVariables$2(inp) {
  return {
    id: inp.id
  };
}

function makeVariables$2(id, param) {
  return {
    id: id
  };
}

let UnarchiveProductMutation_inner = {
  Raw: Raw$2,
  query: query$2,
  parse: parse$2,
  serialize: serialize$2,
  serializeVariables: serializeVariables$2,
  makeVariables: makeVariables$2
};

let include$2 = ApolloClient__React_Hooks_UseMutation.Extend({
  query: query$2,
  Raw: Raw$2,
  parse: parse$2,
  serialize: serialize$2,
  serializeVariables: serializeVariables$2
});

let use$2 = include$2.use;

let UnarchiveProductMutation_useWithVariables = include$2.useWithVariables;

let UnarchiveProductMutation = {
  UnarchiveProductMutation_inner: UnarchiveProductMutation_inner,
  Raw: Raw$2,
  query: query$2,
  parse: parse$2,
  serialize: serialize$2,
  serializeVariables: serializeVariables$2,
  makeVariables: makeVariables$2,
  use: use$2,
  useWithVariables: UnarchiveProductMutation_useWithVariables
};

function useUpdate(id) {
  let match = use(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  let mutate = match[0];
  return React.useCallback((param, state) => {
    let input = makeInputObjectInputUpdateProduct(undefined, undefined, undefined, undefined, undefined, undefined, I18n.t("France"), undefined, undefined, undefined, undefined, Scalar.Text.serialize(state.internalNote), undefined, undefined, undefined, undefined);
    return Future.mapOk(ApolloHelpers.mutationPromiseToFutureResult(mutate(undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
      id: id,
      input: input
    })), undefined, param => param.updateProduct.id);
  }, [id]);
}

function useArchive(id) {
  let match = use$1(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  let mutate = match[0];
  return React.useCallback(() => Future.mapOk(ApolloHelpers.mutationPromiseToFutureResult(mutate(undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
    id: id
  })), undefined, param => id), [id]);
}

function useUnarchive(id) {
  let match = use$2(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  let mutate = match[0];
  return React.useCallback(() => Future.mapOk(ApolloHelpers.mutationPromiseToFutureResult(mutate(undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
    id: id
  })), undefined, param => id), [id]);
}

export {
  UpdateProductMutation,
  ArchiveProductMutation,
  UnarchiveProductMutation,
  useUpdate,
  useArchive,
  useUnarchive,
}
/* query Not a pure module */
